export const featureFlags = {
  ALLOW_TASKS: 'allowTasks',
  ALLOW_NESTED_TEAMS: 'allowNestedTeams',
  ALLOW_IDEAS: 'allowIdeas',
  ALLOW_INITIATIVES_TAB: 'allowInitiativesTab',
  ALLOW_ACTIVITY_TAB: 'allowActivityTab',
  ALLOW_VISION: 'allowVision',
  ALLOW_PRIVATE_TEAMS: 'allowPrivateTeams',
  ALLOW_BILLING: 'allowBilling',
  ALLOW_AI: 'allowAi',
  MAX_USER_COUNT: 'maxUserCount',
  MAX_GOAL_COUNT: 'maxGoalCount',
  MAX_INITIATIVE_COUNT: 'maxInitiativeCount',
  MAX_CUSTOM_FIELD_COUNT: 'maxCustomFieldCount',
  ALLOW_YOUR_WORK_NEW_LAYOUT: 'allowYourWorkNewLayout',
  ALLOW_PROJECTS: 'allowProjects',
  ALLOW_ORG_BASED_CHECKIN_TEMPLATE: 'allowOrgBasedCheckinTemplate',
  ALLOW_COMPUTED_FIELDS: 'allowComputedFields'
}

export const FEATURE_TYPE = {
  BOOLEAN: 'boolean',
  INTEGER: 'integer'
}
export const FEATURE_CONFIG = {
  [featureFlags.ALLOW_NESTED_TEAMS]: FEATURE_TYPE.BOOLEAN,
  [featureFlags.ALLOW_IDEAS]: FEATURE_TYPE.BOOLEAN,
  [featureFlags.ALLOW_INITIATIVES_TAB]: FEATURE_TYPE.BOOLEAN,
  [featureFlags.ALLOW_ACTIVITY_TAB]: FEATURE_TYPE.BOOLEAN,
  [featureFlags.ALLOW_VISION]: FEATURE_TYPE.BOOLEAN,
  [featureFlags.ALLOW_TASKS]: FEATURE_TYPE.BOOLEAN,
  [featureFlags.MAX_USER_COUNT]: FEATURE_TYPE.INTEGER,
  [featureFlags.MAX_GOAL_COUNT]: FEATURE_TYPE.INTEGER,
  [featureFlags.MAX_INITIATIVE_COUNT]: FEATURE_TYPE.INTEGER,
  [featureFlags.ALLOW_PRIVATE_TEAMS]: FEATURE_TYPE.BOOLEAN,
  [featureFlags.MAX_CUSTOM_FIELD_COUNT]: FEATURE_TYPE.INTEGER
}
